import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { AffinityRule } from "../../recommendation.types";

export const requestGetAffinityRules = async (): Promise<AffinityRule[]> => {
  return await instance.get(ApiRoutesRecommendation.Affinity);
};
